'use strict';
const angular = require('angular');

import {FirebaseMqServiceProvider} from './FirebaseMqService';
import {FirebaseQueueDispatcherProvider} from './FirebaseQueueDispatcher';
import {FirebaseQueueServiceProvider} from './FirebaseQueueService';

module.exports = angular
  .module('firebaseMq', [
    'AngularFire.util'
  ])
  .provider('FirebaseMqService', FirebaseMqServiceProvider)
  .provider('FirebaseQueueDispatcher', FirebaseQueueDispatcherProvider)
  .provider('FirebaseQueueService', FirebaseQueueServiceProvider)
;



// WEBPACK FOOTER //
// ./src/js/_libs/firebase-mq/index.js